import React, { useEffect, useState, useRef } from 'react'
import { CreateUrl, CallGetAPI, CallPutAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import ClipLoader from "react-spinners/ClipLoader";
import { GoogleMap, LoadScriptNext, Marker, OverlayView, Map } from "@react-google-maps/api";
import { Button, TextField } from '@mui/material';
import targetCursor from '../../assets/target-cursor.png';
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import orangeMarker from '../../assets/mapLocationMarkers/pinOrange.png';
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';
import WidthAnimation from '../../Animation Wrappers/WidthAnimation';
import { Padding } from '@mui/icons-material';
import NumberField from '../../components/CustomInput/NumberField'
interface Props {
    gps: GPS
    serial: number
    setLoggerLocation: (latitude: number, Longitude: number) => void
}

interface GPS {
     lat: number | undefined | null, lng: number | undefined | null 
}

interface Temp {
    W3W: string
    lat: number
    lng: number
}

interface MarkerType {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    //tooltip: string
}

interface W3WApi {
    coordinates: GPS
    country: string
    language: string
    map: string
    nearestPlace: string
    square: {
        northwest: GPS
        southwest: GPS
    }
    words: string
}

const GoogleMapsGPSSet: React.FC<Props> = ({ gps, serial, setLoggerLocation }) => {

    const defaultCenter = window.location.hostname.includes("zonelog.net")
        ? { lat: 47.17442830752493, lng: 8.517189402835617 }
        : { lat: 50.744094943532446, lng: -3.99597602646894 };


    const mapRef = useRef<Map | null>(null)
    const mapContainerRef = useRef(null)
    //State

    const [W3W, setW3W] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)
    const [center, setCenter] = useState<GPS>(defaultCenter)
    const [mapKey, setMapKey] = useState<string>("")
    const [noGPS, setNoGPS] = useState<boolean>(false)
    const [editMode, setEditMode] = useState<boolean>(false)
    const [marker, setMarker] = useState<MarkerType | null>()
    const [temp, setTemp] = useState<Temp>({ W3W: "", lat: defaultCenter.lat, lng: defaultCenter.lng })
    const [confirmLocation, setConfirmLocation] = useState<boolean>(false)
    const [disableLatLng, setDisableLatLng] = useState<boolean>(false)


    const containerStyle = {
        height: "620px",
        width: "100%",
        marginLeft: "5px",
        minHeight: "500px",
    };

    const editStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 0 0 0",
        width: "100%",
        boxShadow: "2px 2px 10px #00000060",
        marginBottom: "30px",
        justifyContent: "center",
        alignItems: "center"
    }

    const mapStyles = [
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide all labels for Points of Interest (e.g., hospital, park)
        },
        {
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide business-related labels (e.g., shops, restaurants)
        },
        {
            featureType: "poi.medical",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide medical-related labels (e.g., hospital, clinic)
        },
        {
            featureType: "poi.place_of_worship",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide places of worship labels
        },
        {
            featureType: "poi.school",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide school labels
        }
    ];
    // initial Loader
    useEffect(() => {
        setLoading(true)

            reloadData()

        
        
    }, [gps])

    const reloadData = ():void => {
        setLoading(true)
        CallGetAPI(CreateUrl('/api/aquaguard/mapkey'), {})
            .then(d => {
                
                setMapKey(d)
                CallGetAPI(CreateUrl('/api/aquaguard/what3wordsApi'), {})
                    .then(data => {

                        if (gps && gps.lat && gps.lng) {
                            setNoGPS(false)
                            setCenter(gps)
                            setMarker({
                                position: { lat: gps.lat, lng: gps.lng },
                                icon: yellowMarker,
                                serial: serial

                            })
                            fetch(`https://api.what3words.com/v3/convert-to-3wa?coordinates=${gps.lat}%2C${gps.lng}&key=${data}`)
                                .then(async response => {
                                    if (response.ok) {
                                        return response.json()

                                    }
                                })
                                .then((w3w: W3WApi) => {
                                    setW3W(w3w.words)
                                    
                                })
                                .catch(err => {
                                    console.error(err)

                                })
                        } else {
                                setNoGPS(true)
                                
                        }
                      
                    })
                    .then(() => {
                        setLoading(false)
                    })
                    .catch(err => {
                        console.error(err)

                    })
                    
            })
            
            .catch(err => {
                console.log(err)
                setLoading(false)
            });
    }
    const onMapLoad = (map):void => {
        mapRef.current = map;
        map.setMapTypeId("hybrid")
        mapRef.current.setZoom(18)
        map.setOptions({Padding: 0})

    }

    const createGPSLocation = ():void => {
        setEditMode(true)
        setNoGPS(false)
    }

    const handleEditClick = ():void => {
        setEditMode(!editMode)
        handleReset()
    }


    const handleMouseOver = ():void => {
        if (mapRef.current) {
            if (editMode && !confirmLocation) {
                mapRef.current.setOptions({
                    draggableCursor: `url(${targetCursor}) 32 32, auto`,
                    
                });
            } else {
                mapRef.current.setOptions({
                    draggableCursor: null,
                });
            }
        } 
    };


    const handleMapClick = async (e: any): Promise<void> => {
        if (!confirmLocation) {
            const lat = e.latLng.lat()
            const lng = e.latLng.lng()
            const tempDeets = { ...temp }
            tempDeets.lat = lat
            tempDeets.lng = lng
            setMarker({
                position: { lat, lng },
                serial,
                icon: orangeMarker
            })
            try {
                const response = await CallGetAPI(CreateUrl('/api/aquaguard/what3wordsApi'), {})
                const api = response
                fetch(`https://api.what3words.com/v3/convert-to-3wa?coordinates=${tempDeets.lat}%2C${tempDeets.lng}&key=${api}`)
                    .then(async response => {
                        if (response.ok) {
                            return response.json()

                        }
                    })
                    .then((w3w: W3WApi) => {
                        console.log(w3w)
                        tempDeets.W3W = w3w?.words
                        setTemp(tempDeets)
                        setConfirmLocation(true)
                    })
                    .catch(err => {
                        console.error(err)
                        setConfirmLocation(true)
                    })
            }
            catch (error) {
                console.error(error)
                setConfirmLocation(true)
            }
        }
        
    }

    const handleCoordChange = (e: number, name: string): void => {

        const tempDeets: Temp = { ...temp }
            tempDeets[name] = parseFloat(e)
        tempDeets.W3W = ""

        setTemp(tempDeets)
    }

    const handleW3WChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const tempDeets = {...temp}
        const value: string = e.target.value

        tempDeets.W3W = value
        if (value) {
            setDisableLatLng(true)
        } else {
            setDisableLatLng(false)
        }
        setTemp(tempDeets)
    }


    const handleCheckCoords = async (): void => {
        
        if (!confirmLocation) {
            try {
                const response = await CallGetAPI(CreateUrl('/api/aquaguard/what3wordsApi'), {})
                const api = response
                console.log(disableLatLng)
                if (disableLatLng) {
                    if (!temp.W3W) {
                        alert('You must set what three words')
                        return
                    }
                    fetch(`https://api.what3words.com/v3/convert-to-coordinates?words=${temp.W3W}&key=${api}`)
                        .then(async response => {
                            if (response.ok) {
                                return response.json()

                            }
                        })
                        .then((w3w: W3WApi) => {
                            const tempDeets = { ...temp }
                            tempDeets.lat = w3w.coordinates.lat
                            tempDeets.lng = w3w.coordinates.lng
                            setTemp(tempDeets)
                            setMarker({
                                position: { lat: tempDeets.lat, lng: tempDeets.lng },
                                icon: orangeMarker,
                                serial: serial
                            })
                        })
                        .catch(err => {
                            console.error(err)
                        }) 


                } else {

                    if (!temp.lat || !temp.lng) {
                        alert('Latitude or Longitude must be set')
                        return
                    }
                    if ((temp.lat || temp.lng) && temp.W3W) {
                        alert('Cannot use both lat and long and what 3 words at the same time')
                        return
                    }
                    setMarker({
                        position: { lat: temp.lat, lng: temp.lng },
                        icon: orangeMarker,
                        serial: serial
                    })

                    fetch(`https://api.what3words.com/v3/convert-to-3wa?coordinates=${temp.lat}%2C${temp.lng}&key=${api}`)
                        .then(async response => {
                            if (response.ok) {
                                return response.json()

                            }
                        })
                        .then((w3w: W3WApi) => {

                            const tempDeets = { ...temp }
                            tempDeets.W3W = w3w.words
                            setTemp(tempDeets)
                        })
                        .catch(err => {
                            console.error(err)
                        })

                    
                }
                setConfirmLocation(true)
            } catch (error) {
                console.error(error)
            }
        } else {
            setLoggerLocation(temp.lat, temp.lng)
            setEditMode(false)
            setConfirmLocation(false)
        }
    }

    useEffect(() => {
        if (marker) {
            setCenter(marker.position)
        }
    }, [marker])
    
    const handleReset = ():void => {
        setConfirmLocation(false)

        if (gps && gps.lat && gps.lng) {
            setTemp({ lat: gps.lat, lng: gps.lng, W3W })
            setCenter(gps)
            setMarker({
                position: { lat: gps.lat, lng: gps.lng },
                icon: yellowMarker,
                serial: serial
            })
        } else {
            setMarker(null)
            setNoGPS(true)
            setCenter(defaultCenter)
        }
    }

    
    return (
        <div>
            {loading &&
                <div style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    <ClipLoader
                        size={150}
                        color={"#123abc"}
                        loading={loading}
                    />
                </div>}
            {!loading && <div>
                <div style={{display: "flex", width: "100%", justifyContent: "space-between", marginBottom: "20px"} }>
                    <h4>Device Location</h4>
                    {!noGPS && <Button variant="contained" color={editMode ? 'error' : 'primary'} onClick={(): void => handleEditClick()}>{editMode ? 'Cancel' : 'Edit GPS'} </Button>}
                </div>
                <div>
                    {noGPS && <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                        <div>
                            <h5>No GPS data Found</h5>
                            <Button onClick={(): void => createGPSLocation()} variant="contained">Set GPS Location</Button>
                        </div>
                    </div>}
                    {!noGPS && <div style={{ display: "flex" }}>
                        <WidthAnimation initialWidth="100%" targetWidth={editMode ? "80%" : "100%"} duration={0.8 }>
                            {mapKey && <LoadScriptNext googleMapsApiKey={mapKey}>
                                <div ref={mapContainerRef}>
                                <GoogleMap
                                    center={center}
                                    options={{
                                        styles: mapStyles,
                                        disableDefaultUI: false
                                    }}
                                    mapContainerStyle={containerStyle}
                                    onLoad={onMapLoad}
                                    ref={mapRef}
                                    onMouseOver={():void => handleMouseOver()}
                                    onClick={(e):void => handleMapClick(e) }
                                    >
                                        {marker && marker.position.lat && marker.position.lng && <React.Fragment>
                                            <Marker
                                                position={marker.position}
                                                icon={marker.icon}
                                            />
                                        </React.Fragment>}
                                    
                                    </GoogleMap>
                                </div>
                            </LoadScriptNext>}
                        </WidthAnimation>
                        {editMode &&
                            <div style={{outline: "red", width: "20%"} }>
                            <SlideInAnimation direction="bottom" duration={1.2} delay={1} transitionAmount={400} isVisible={editMode}>
                                <div style={{ width: "100%", padding: "0 10px 0 30px" }}>
                                <div style={{
                                    borderLeft: "10px solid #00bf00",
                                    ...editStyle,
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center"
                                        }}>
                                    <div>
                                        {!confirmLocation && <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                    <div>
                                                        <h4 style={{ textAlign: "center", marginTop: "10px" }}><b>Edit GPS</b></h4>


                                                    </div>
                                            <div>
                                                <h5 style={{ textAlign: "center" }}>Set Location on the Map</h5>
                                                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                    <p style={{ margin: "0 10px" }}>Find the location on the<br /> map and left click to set</p>
                                                </div>
                                            </div>
                                            <h4 style={{ textAlign: "center", margin: "10px 0" }}><b>OR</b></h4>
                                            <h5 style={{ textAlign: "center" }}>Enter Lat and Long</h5>
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <NumberField
                                                    size="small"
                                                    label="Latitude"
                                                    value={temp.lat}
                                                    name="lat"
                                                            onValueChange={(e:number): void => handleCoordChange(e, 'lat')}
                                                    disabled={disableLatLng }
                                                />
                                            </div>
                                            <div style={{ marginTop: "10px", display: "flex", justifyContent: "center" }}>
                                                <NumberField
                                                    size="small"
                                                    label="Longitude"
                                                    value={temp.lng}
                                                    name="lng"
                                                    onValueChange={(e:number): void => handleCoordChange(e, 'lng')}
                                                    disabled={disableLatLng}
                                                />
                                            </div>
                                            <h4 style={{ textAlign: "center", margin: "10px 0" }}><b>OR</b></h4>
                                            <h5 style={{ textAlign: "center" }}>Enter What Three Words</h5>
                                            <div style={{ margin: W3W === temp.W3W ? "10px 0 20px 0" : "10px 0", display: "flex", justifyContent: "center" }}>
                                                <TextField
                                                    size="small"
                                                    label="word1.word2.word3"
                                                    value={temp.W3W}
                                                    onChange={(e):void => handleW3WChange(e) }
                                                />       
                                            </div>
                                                
                                                </div>}
                                                {confirmLocation && <div>
                                                    <div>
                                                        <h4 style={{ textAlign: "center", marginTop: "10px" }}><b>GPS Details</b></h4>
                                                    </div>
                                                    <h5 style={{ textAlign: "center" }}>Latitude: <b>{temp.lat}</b></h5>
                                                    <h5 style={{ textAlign: "center" }}>Longitude: <b>{temp.lng}</b></h5>
                                                    <h5 style={{ textAlign: "center" }}>What Three Words for this location</h5>
                                                    <h5 style={{ textAlign: "center" }}><b>{temp.W3W}</b></h5>
                                                </div> }
                                        {(W3W !== temp.W3W || ((gps.lat !== temp.lat || gps.lng !== temp.lng) && (gps.lat && gps.lng))) && <div style={{ display: "flex", justifyContent: "center", margin: "0 0 20px 0 " }}>
                                            <Button variant="contained" color={confirmLocation ? 'warning' : 'primary'} onClick={(): void => handleCheckCoords()}>{confirmLocation ? "Confirm Location" : "Check Location"}</Button>
                                                    {confirmLocation && <Button variant="contained" style={{ marginLeft: "10px" }} color="error" onClick={():void => handleReset() }>Redo</Button>}
                                            </div>}
                                    </div>
                                </div>
                            </div>
                                </SlideInAnimation>
                    </div>}
                    </div>}
                </div>
            </div>}
        </div>
    )
}
export default GoogleMapsGPSSet